// import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPosLookupList } from '@store/Sales/Pos/PosSlice';
import { useTranslation } from 'react-i18next';

const useGetPosLookupList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();

  useEffect(() => {
    dispatch(getPosLookupList());
  }, []);

  const { PosLookupList, loading, error } = useAppSelector(state => state.Pos);

  const optionsPos = PosLookupList?.map(m => ({
    value: m.id,
    label: i18n.language === 'en' ? m.name : m.name2
  }));

  return { PosLookupList, optionsPos, loading, error };
};

export default useGetPosLookupList;
